module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('p', {
    staticClass: "btn fp leading"
  }, [_c('a', {
    attrs: {
      "id": "page_normal--num_1--seq_1"
    }
  }, [_c('b', [_vm._v("‘I fear that if I asked you to walk ")]), _vm._v(" "), _c('b', [_vm._v("with me in the gardens for a few ")]), _vm._v(" "), _c('b', [_vm._v("minutes you would refuse.’")])])]), _c('a', {
    attrs: {
      "id": "page_normal--num_1--seq_1"
    }
  }, [_c('p', {
    staticClass: "btn fp leading"
  }, [_vm._v("‘We hardly know each other well enough for that, sir.’ ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp leading"
  }, [_vm._v("‘We do not know each other at all, Miss Holbrook.’ Freddie let one finger trail down Caroline’s arm, sending a frisson of sensation shooting through her. For a moment, as she stared into his dark eyes, she felt as if she were drowning. Being sucked down and down into a swirling pool and out of her depth. ‘I am not sure that it would be to the benefit of either of us to become more intimately acquainted…’ ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("‘Then please allow me to pass,’ Caroline said, and gave him a frosty stare. Until that moment she had been revising her opinion of him, and liking what she had discovered, but now she was once again aware of the danger of allowing herself to like such a man. If she were foolish enough to develop a "), _c('i', [_vm._v("tendre")]), _vm._v(" for him, he would be sure to break her heart. ")])])]), _c('a', {
    attrs: {
      "id": "page_normal--num_1--seq_1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f7b5f14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781408901175_excerpt.vue
// module id = 57
// module chunks = 0